import React from 'react'
import { Button } from 'react-bootstrap'
import { Modal } from 'react-bootstrap'
import { SingleTransfer, SingleTransferBetmoney } from '../../../../../Api/UserPanel/models'
import { formatUTCtoArgentinaTime } from '../../../../../../Utils/Utils'
import { BiLoaderCircle } from 'react-icons/bi'
import { useGetPlayerCoinHistoryBetmoney } from '../../../../../Hooks/Users/useGetPlayerCoinHistoryBetmoney'
interface Props {
    show: boolean
    onHide: () => void

    form: {
        name: string
    }
}


export const PlayerCoinHistoryBetmoneyModal = ({ show, onHide, form }: Props) => {
    const { playerCoinHistory, loading } = useGetPlayerCoinHistoryBetmoney({ form })

    const historyArray = playerCoinHistory?.data?.content?.logs
    const getHistoryColor = (e: SingleTransferBetmoney) => {
        if (e?.operation === 'in') { return 'green' }
        if (e?.operation === 'out') { return 'red' }
        if (e?.operation === 'reward_in') { return 'orange' }
        return '';
    }

    const getHistoryLabel = (e: SingleTransferBetmoney) => {
        if (e?.operation === 'in') { return 'Carga' }
        if (e?.operation === 'out') { return 'Descarga' }
        if (e?.operation === 'reward_in') { return 'Bonificación' }
        return '';
    }


    const elevenHsAheadHistory = (date: string) => {
        // add 11 hs to date
        const date_ = new Date(date)
        const elevenhsAhead = new Date(date_.setHours(date_.getHours() + 11))
        return formatUTCtoArgentinaTime(elevenhsAhead.toISOString())
    }


    return (
        <Modal show={show} onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title>Historial de cargas/retiros {form.name}</Modal.Title>
            </Modal.Header>
            <span className='text-warning text-xs p-3'>*Los movimientos pueden demorar unos 1 o 2 minutos en reflejarse desde que se realizan.</span>

            <div className='text-secondary mb-3 d-flex flex-column px-3'>Rango: Últimos 30 días.</div>

            <Modal.Body>
                {!loading && historyArray && historyArray?.length > 0 &&
                    <div className="text-primary mb-3 d-flex flex-column">
                        <div className='d-flex flex-column'>
                            <div>Total: {playerCoinHistory?.data?.TotalAmount} fichas.</div>
                            <div>Total Bonificaciones: {playerCoinHistory?.data?.balance_wager} fichas.</div>
                            <div>Total Retirable: {playerCoinHistory?.data?.balance_withdraw} fichas.</div>
                        </div>
                    </div>
                }


                {historyArray && historyArray?.length === 0 &&
                    <div className='d-flex justify-content-center'>
                        <span>No hay historial de cargas/retiros</span>
                    </div>
                }

                <div className='d-flex justify-content-center'>
                    {loading && <div className='d-flex justify-content-center my-5 gap-2 align-items-center'>
                        <div className='spin-animation d-flex align-items-center justify-content-center'>
                            <BiLoaderCircle size={20} />
                        </div>
                        <span>Cargando...</span>
                    </div>}


                    {!loading && <div>
                        {historyArray?.map((item: SingleTransferBetmoney) => (
                            <div key={item.id}>
                                <div style={{ color: getHistoryColor(item) }} className="d-flex gap-2">
                                    <span>[{elevenHsAheadHistory(item.dateTime)}]</span>
                                    {/* <span>{item.account.login}</span> */}
                                    <span>{item.cash}</span>
                                    <span>({getHistoryLabel(item)})</span>
                                </div>
                            </div>


                        ))}
                    </div>}

                </div>
            </Modal.Body>
            <Modal.Footer>

                <Button variant="secondary" onClick={onHide}>
                    Cerrar
                </Button>
            </Modal.Footer>
        </Modal>)
}
